import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border p-x2 md:p-x3 border-silver" }

import { PickAndPackCheckOutDeliverable } from '@/b2b/shared/api/server-apis';
import CheckoutPickAndPackHomeDeliveryInfo
    from '@/b2b/checkout/ui/deliverables/pick-and-pack/CheckoutPickAndPackHomeDeliveryInfo.vue';
import CheckoutDeliverableGoToNext from '@/b2b/checkout/ui/CheckoutDeliverableGoToNext.vue';
import BlockLabelWithNamedArguments from '@/shared/BlockLabelWithNamedArguments.vue';
import CheckoutDeliverableItems from '@/b2b/checkout/ui/items/CheckoutDeliverableItems.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPickAndPackDeliverable',
  props: {
    deliverable: null,
    index: null
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.deliverable.text)
      ? (_openBlock(), _createBlock(BlockLabelWithNamedArguments, {
          key: 0,
          label: __props.deliverable.text,
          class: "mb-x4 text-center"
        }, null, 8, ["label"]))
      : _createCommentVNode("", true),
    (__props.deliverable.id)
      ? (_openBlock(), _createBlock(CheckoutDeliverableItems, {
          key: 1,
          deliverable: __props.deliverable
        }, null, 8, ["deliverable"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(CheckoutPickAndPackHomeDeliveryInfo, { deliverable: __props.deliverable }, null, 8, ["deliverable"])
    ]),
    _createVNode(CheckoutDeliverableGoToNext, {
      index: __props.index,
      deliverable: __props.deliverable
    }, null, 8, ["index", "deliverable"])
  ]))
}
}

})